import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GoldenButton from "../Components/GoldenButton/GoldenButton";
import "./OrderSummary.css";

const OrderSummary = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const API_BASE_URL = "https://fliplyn-b-c.fly.dev";

  const { cartItems = [], subtotal = 0, gst = 0, grandTotal = 0 } =
    location.state || {};

  const handleConfirmOrder = async () => {
    try {
      setLoading(true);

      const guestRaw = localStorage.getItem("kanchiGuest");

      if (!guestRaw) {
        alert("Guest details not found. Please re-enter.");
        navigate("/guest-entry");
        return;
      }

      const guestData = JSON.parse(guestRaw);

      const tableNumber = localStorage.getItem("table_number");

      if (!tableNumber) {
        alert("Table information missing. Please scan QR again.");
        navigate("/scan-table");
        return;
      }

      const formattedItems = cartItems.map((item) => ({
        item_id: item.id,
        quantity: item.quantity,
      }));

      const payload = {
        cafe_id: "e7b20008-f754-402a-944c-027bf11d68c0",
        user_name: guestData.name,
        user_phone: guestData.mobile.replace("+91", ""),
        number_of_guests: guestData.guests,
        table_number: tableNumber,
        items: formattedItems,
      };

      const response = await fetch(`${API_BASE_URL}/orders/cafe/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const rawText = await response.text();

      if (!response.ok) {
        throw new Error(`Order failed with status ${response.status}`);
      }

      JSON.parse(rawText);

      localStorage.removeItem("kanchi_cart");
      localStorage.removeItem("kanchiGuest");

      navigate("/kanchi-success");

    } catch (error) {
      console.error("Order error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!cartItems.length) {
    return <h2 style={{ textAlign: "center" }}>No order data found.</h2>;
  }

  return (
    <div className="summary-page">
      <div className="summary-card">
        <h1 className="summary-title">Order Summary</h1>

        <div className="items-section">
          {cartItems.map((item) => (
            <div key={item.id} className="item-row">
              <span className="item-name">
                {item.name} × {item.quantity}
              </span>
              <span className="item-total">
                ₹{item.price * item.quantity}
              </span>
            </div>
          ))}
        </div>

        <div className="divider" />

        <div className="price-row">
          <span>Subtotal</span>
          <span>₹{subtotal}</span>
        </div>

        <div className="price-row">
          <span>GST (5%)</span>
          <span>₹{gst}</span>
        </div>

        <div className="total-row">
          <span>Total</span>
          <span className="total-amount">₹{grandTotal}</span>
        </div>

       <div className="confirm-btn-wrapper">
            <GoldenButton onClick={handleConfirmOrder}>
                {loading ? "Placing Sacred Order..." : "Confirm Order"}
            </GoldenButton>
            </div>
      </div>
    </div>
  );
};

export default OrderSummary;